import React from 'react';

export const BoltIcon: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='6' height='12' viewBox='0 0 6 12' fill='none'>
    <path
      d='M5.92417 5.63147C5.97184 5.54881 5.99798 5.45408 5.99989 5.35705C6.0018 5.26003 5.97941 5.16421 5.93503 5.07949C5.89066 4.99477 5.8259 4.92421 5.74743 4.87508C5.66896 4.82595 5.57963 4.80003 5.48865 4.8H3.75008V0L0.0759205 6.36907C0.0282088 6.45168 0.00203919 6.54639 0.000114419 6.6434C-0.00181035 6.74041 0.0205794 6.83621 0.0649716 6.92091C0.109364 7.00561 0.174149 7.07613 0.252636 7.12519C0.331123 7.17425 0.420466 7.20008 0.511439 7.2H2.25001V12L5.92417 5.63147Z'
      fill='#3C0059'
    />
  </svg>
);
